const placeholderCss = {
  display: "inline-block",
  fontSize: "13px",
  fontStyle: "normal",
  fontWeight: "normal",
  lineHeight: "28px",
  verticalAlign: "middle",
};

export default placeholderCss;
